// test1822
(1822 && 0);
